import { useEffect, useState } from 'react';
import type { Environment } from 'react-relay';
import { userHasRovoDevAgentsAccess } from './user-has-rovo-dev-agents-access.tsx';

export const useHasRovoDevAgentsEntitlement = (
	atlassianAccountId: string | null,
	cloudId: string,
	relayEnv: Environment,
	shouldCheckEntitlement: boolean,
): { hasRovoDevAgentsEntitlement: boolean } => {
	const [hasRovoDevAgentsEntitlement, setHasRovoDevAgentsEntitlement] = useState(false);

	useEffect(() => {
		if (!atlassianAccountId || !shouldCheckEntitlement) {
			return;
		}
		userHasRovoDevAgentsAccess({ atlassianAccountId, cloudId, relayEnv }).then((hasAccess) => {
			setHasRovoDevAgentsEntitlement(hasAccess);
		});
	}, [atlassianAccountId, cloudId, relayEnv, shouldCheckEntitlement]);

	return { hasRovoDevAgentsEntitlement };
};
